import React from 'react';
const tomos = [{
  color: '🟢',
  title: 'Tomo 1 — Ambientación',
  desc: 'Primer contacto · Miedo al agua · Flotación básica',
  sessions: '25'
}, {
  color: '🟡',
  title: 'Tomo 2 — Flotación y Propulsión',
  desc: 'Posición hidrodinámica · Patada crol/espalda · Primeros 25m',
  sessions: '25'
}, {
  color: '🟠',
  title: 'Tomo 3 — Crol y Espalda',
  desc: 'Crol 100m · Espalda completa · Virajes · Salidas',
  sessions: '25'
}, {
  color: '🔴',
  title: 'Tomo 4 — Pecho, Mariposa y Virajes',
  desc: 'Los 4 estilos · Tumble turn · 200m Medley',
  sessions: '25'
}, {
  color: '🟣',
  title: 'Tomo 5 — Pre-Equipo y Competencia',
  desc: 'Microciclos · Series aeróbicas/anaeróbicas · Primera competencia',
  sessions: '25'
}, {
  color: '⭐',
  title: 'Tomo 6 — Adultos y Master Fitness',
  desc: 'Adultos principiantes · Natación fitness · Master 40+ · Terapéutica',
  sessions: '25'
}];
const features = ['Planificación anual lista', 'Sistema "Abrir y Dar Clase"', 'Fichas de evaluación por alumno', 'Variantes por nivel'];
export function WhatYouGet() {
  return <section className="w-full bg-[#0A0A0F] py-14 px-4" data-id="element-242">
      <div className="max-w-3xl mx-auto" data-id="element-243">
        <h2 className="text-3xl sm:text-4xl font-black text-white text-center mb-2" data-id="element-244">
          Los 6 Tomos <span className="text-[#FF6B00]" data-id="element-245">Completos</span>
        </h2>
        <p className="text-[#B0B0C0] text-center text-sm mb-8" data-id="element-246">
          150 sesiones · Por nivel · Evaluación incluida
        </p>

        {/* Tomos list */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-6" data-id="element-247">
          {tomos.map(tomo => <div key={tomo.title} className="bg-[#16161F] border border-[#FF6B0033] rounded-xl p-4 flex items-start gap-3" data-id="element-248">
              <span className="text-2xl flex-shrink-0 mt-0.5" data-id="element-249">
                {tomo.color}
              </span>
              <div className="flex-1 min-w-0" data-id="element-250">
                <div className="flex items-center justify-between gap-2 mb-1" data-id="element-251">
                  <h3 className="font-bold text-white text-sm" data-id="element-252">{tomo.title}</h3>
                  <span className="text-[#FF6B00] text-[10px] font-bold bg-[#FF6B0033] px-2 py-0.5 rounded-full flex-shrink-0" data-id="element-253">
                    {tomo.sessions} sesiones
                  </span>
                </div>
                <p className="text-[#B0B0C0] text-xs leading-relaxed" data-id="element-254">
                  {tomo.desc}
                </p>
              </div>
            </div>)}
        </div>

        {/* Features */}
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-2" data-id="element-255">
          {features.map(f => <div key={f} className="bg-[#16161F] border border-[#FF6B0033] rounded-lg px-3 py-2.5 text-center" data-id="element-256">
              <span className="text-[#FF6B00] text-base block mb-0.5" data-id="element-257">✅</span>
              <span className="text-white text-[11px] sm:text-xs font-semibold leading-tight" data-id="element-258">
                {f}
              </span>
            </div>)}
        </div>
      </div>
    </section>;
}